import React from 'react';
import classNames from 'classnames';

interface IProps {
	className?: string;
}

export const Tabs: React.FC<IProps> = ({ className, children }) => (
	<div className={classNames('w-full flex gap-6 border-0 border-b border-solid border-purple-02-new', className)}>
		{children}
	</div>
);
